// ##### 25-02-12 Komarov
export function getDomain(url) {
  // Use regex to match domain between protocol and trailing slash
  const match = url.match(/https?:\/\/([\w.-]+)/);
  return match ? match[1] : null;
}
